export const ASK_CENNA_SUGGESTIONS = [
  "Summarize this document",
  "How does this align with our playbook?",
  "What clauses need attention before signing?",
  "Suggest edits for the selected text",
  "List related tickets for this contract",
] as const;

export const ASK_CENNA_SELECTION_PROMPT = "Suggest edits for the selected text";
